// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"g5-z","button":"h5-z","disabled":"i5-z","creditCard":"j5-z","wrapper":"k5-z"};